<template lang="pug">
.location-item
  .location-item__header()
    span.location-item__title {{ item.name }}
    crud(
      :item="item"
      editable
      :ID="+$route.query.course_id"
      @update="$emit('update', $event)"
    )
  .location-item__body
    .location-item__spacer
      .location-item__item
        v-icon(color="primary" size="16").location-item__item-icon mdi-map-marker
        span.location-item__text {{ selectedLocation.address }}
      .location-item__item
        v-icon(color="primary" size="16").location-item__item-icon mdi-post
        span.location-item__text {{ selectedLocation.postal_code }}
      .location-item__item
        v-icon(color="primary" size="16").location-item__item-icon mdi-map-marker-distance
        span.location-item__text 
          a(:href="selectedLocation.route_link" target="_blank") {{ selectedLocation.route_from }}
      
      .location-item__item 
        v-icon(color="primary" size="16").location-item__item-icon mdi-account-clock
        span.location-item__text {{ item.gather_time | DeleteMS }}
      .location-item__item 
        v-icon(color="primary" size="16").location-item__item-icon mdi-clock-outline
        span.location-item__text {{ item.course_start_time | DeleteMS}} - {{ item.course_end_time | DeleteMS }}
    v-divider.mt-2.mt-2
    .location-item__spacer
      p.location-item__subtitle CBR
      .location-item__item
        v-icon(color="primary" size="16").location-item__item-icon mdi-map-marker
        span.location-item__text {{ item.cbr_location }}
      .location-item__item 
        v-icon(color="primary" size="16").location-item__item-icon mdi-clock-outline
        span.location-item__text {{ item.exam_time | DeleteMS }}
      .location-item__item 
        v-icon(color="primary" size="16").location-item__item-icon mdi-car-info
        span.location-item__text {{ item.transport_type }}
    v-divider.mt-2.mb-2(v-if="item.first_day_course_date")
    .location-item__spacer(v-if="item.first_day_course_date")
      p.location-item__subtitle Two day course
      .location-item__item 
        v-icon(color="primary" size="16").location-item__item-icon mdi-calendar
        span.location-item__text {{ item.first_day_course_date }}
      .location-item__item 
        v-icon(color="primary" size="16").location-item__item-icon mdi-clock-outline
        span.location-item__text {{ item.first_day_course_start_time | DeleteMS}} - {{ item.first_day_course_end_time | DeleteMS}}
      

</template>

<script>
import {mapGetters} from "vuex"
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },

  computed: {
    ...mapGetters({
      locations: 'courseLocations/items'
    }),

    selectedLocation() {
      let item = this.locations.find(location => location.id === this.item.meeting_room)
      if(item) return item
      return {}
    }
  },

  methods: {

  },
  components: {
    crud: () => import('./CMLocationCRUD.vue')
  }
}
</script>

<style lang="scss" scoped>
.location-item {
  width: 145px;
  margin-bottom: 14px;
  &__header {
    background-color: $primary-color;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    padding-left: 10px;
    padding-right: 10px;
    min-height: 35px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    &_active {
      background-color: $error-color;
    }
  }
  &__title {
    font-size: 12px;
    color: #fff;
    font-weight: 500;
  }
  &__body {
    padding-bottom: 10px;
    border-left: 1px solid $border-color;
    border-right: 1px solid $border-color;
    border-bottom: 1px solid $border-color;
  }
  &__spacer {
    padding-left: 10px;
    padding-right: 10px;
  }
  &__text {
    color: $title-second;
    font-size: 12px;
    font-weight: 500;
  }
  &__item {
    line-height: 1;
    padding-top: 10px;
    &-icon {
      margin-right: 10px;
    }
  }
  &__count {
    font-size: 18px;
    color: $title-second;
    &_max {
      color: $end-color;
    }
  }
  &__subtitle {
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 0;
  }
}

::v-deep .counts{
  font-size: 12px;
  border: 1px solid $border-color;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;

  &__item:last-child{
    border-bottom-right-radius: 4px;
  }
}
</style>